import { Mods, mods } from '@approvalmax/theme';
import { Button } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const StyledButton = styled(Button)<Mods<'hide'>>`
    ${mods.hide.true`
        visibility: hidden;
    `}
`;
